const sx = {
  container: {
    py: { xs: 4, md: 6 },
    backgroundColor: '#ffffff',
  },
  itemContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: { xs: 'center', md: 'flex-start' },
    gap: 2,
    px: { xs: 2, md: 4 },
  },
  iconBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    pt: 0.5, // Pequeño ajuste para alinear el centro del ícono con la primera línea de texto
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'left',
  },
  title: {
    color: '#1A2342', // Azul oscuro
    fontWeight: 800,
    fontSize: { xs: '1.25rem', md: '1.5rem' },
    textTransform: 'uppercase',
    lineHeight: 1.2,
    mb: 0.5,
  },
  subtitle: {
    color: '#1A2342',
    fontSize: { xs: '0.9rem', md: '1rem' },
    fontWeight: 400,
    lineHeight: 1.4,
  },
}

export default sx
